import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './NavigationStyles.css';

/**
 * Navigation Logic Custom Hook
 * Handles page navigation related states and actions
 * 
 * @returns {Object} Contains navigation states and functions
 */
export function useNavigation() {
  const navigate = useNavigate();
  const isMountedRef = useRef(true);
  const isNavigatingRef = useRef(false);

  // Return to home - Add safe navigation and cleanup logic
  const goToHome = useCallback(() => {
    // Prevent duplicate navigation
    if (isNavigatingRef.current) {
      return;
    }
    
    // Set navigation flag
    isNavigatingRef.current = true;
    
    // Execute necessary cleanup, add short delay to ensure resource release
    try {
      setTimeout(() => {
        if (isMountedRef.current) {
          navigate('/');
        }
      }, 100);
    } catch (error) {
      console.error('Error during navigation cleanup:', error);
      isNavigatingRef.current = false;
      
      // Try to navigate anyway
      navigate('/');
    }
  }, [navigate]);

  return {
    goToHome,
    isMountedRef,
    isNavigatingRef
  };
}

/**
 * Navigation Buttons Component
 * Displays return to home and toggle panel buttons
 */
export function NavigationButtons({ goToHome, showPanel, togglePanel }) {
  return (
    <div className="panel-toggle">
      <button onClick={goToHome} className="toggle-button home-button">
        Return Home
      </button>
      <button onClick={togglePanel} className="toggle-button">
        {showPanel ? "Hide Panel" : "Show Panel"}
      </button>
    </div>
  );
}

/**
 * Navigation Away State Component
 * Displays transition state during navigation
 */
export function NavigatingAway() {
  return <div className="navigating-away">Leaving page...</div>;
} 